import { createFileRoute } from "@tanstack/react-router";
import Desafios from "@/pages/app/Desafios";

export const Route = createFileRoute("/app/desafios")({
  head: () => ({ meta: [{ title: "Desafios | Braussie - Nutri" }] }),
  component: Desafios,
});
